
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header from "components/Headers/Header";
import { Formik } from "formik";
import UseFullPageLoader from "utils/UseFullPageLoader";
import { importVideoGame } from "utils/endpoint";

const ImportVideoGame = () => {
  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [loading, setLoading] = useState(false);
  const [videoGameDataFile, setVideoGameDataFile] = useState("");
  const [VideoGameDataFileError, setVideoGameDataFileError] = useState(null);
  
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        if (event.target.name === "video_game_data") {
          setVideoGameDataFile(base64);
        } 
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSampleCsvFileDownload = () => {
    const link = document.createElement("a");
    console.log(link);
    link.href = `${process.env.PUBLIC_URL}/sample-files/video-game-sample-data.csv`;
    link.download = "video-game-sample-data.csv";
    link.click();
  };

 
  return (
    <Formik
      enableReinitialize
      initialValues={{
        video_game_data: null,
      }}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        if (!values.video_game_data) {
          setVideoGameDataFileError("Data file is required");
        }
       
        if (!values.video_game_data) {
          return false;
        }
        setLoading(true);
        showLoader();

        const finalObj = {
          video_game_data: videoGameDataFile,
        };
        console.log(finalObj);
      
        const result = await importVideoGame(finalObj);
        if (result?.isSuccess) {
          toast.success("Video Game imported successfully!");
          setLoading(false);
          hideLoader();
          resetForm();
          navigate("/admin/videoGame/videoGame-list");
        } else {
          setSubmitting(false);
          setLoading(false);
          hideLoader();
          return toast.error(
            result.message || `Something went wrong, please try again letter!`
          );
        }
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <form onSubmit={handleSubmit} autoComplete="off">
          <>
            <Header />

            <Container className="mt--7" fluid>
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row>
                        <Col lg="6">
                          <h1 className="mb-0">Import Video Game</h1>
                        </Col>
                        <Col lg="6" className="add_btn text-right">
                          <Button
                            color="primary"
                            className=""
                            onClick={() => {
                              navigate("/admin/videoGame/videoGame-list");
                            }}
                          >
                            <span className="me-2">Back</span>
                          </Button>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <div className="d-flex mb-1">
                              <label className="form-control-label required">
                                Video Game Data (*.CSV)
                              </label>
                              <Button
                                className="btn-sm ml-auto"
                                color="primary"
                                title="Download sample csv file of Video Game"
                                onClick={async () => {
                                  handleSampleCsvFileDownload();
                                }}
                              >
                                <i class="fa fa-download"></i>
                              </Button>
                            </div>
                            <div className="form-control w-100 m-0 ">
                              <label
                                className="mb-0 text-muted"
                                style={{ cursor: "pointer" }}
                              >
                                {values?.video_game_data
                                  ? values?.video_game_data
                                  : "Click here to upload csv file"}
                                <i
                                  className="fa fa-upload ml-2"
                                  aria-hidden="true"
                                ></i>
                                <Input
                                  id="video_game_data"
                                  type="file"
                                  accept=".csv"
                                  name="video_game_data"
                                  className="form-control d-none"
                                  onChange={(event) => {
                                    if (event?.target?.files[0]?.name) {
                                      setFieldValue(
                                        "video_game_data",
                                        event?.target?.files[0]?.name || null
                                      );
                                      setVideoGameDataFileError(null);
                                    }
                                    handleFileChange(event);
                                  }}
                                />
                              </label>
                            </div>
                            {VideoGameDataFileError && (
                              <div className="text-danger text-align-top-center mt-1">
                                {VideoGameDataFileError}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="3">
                          <Button
                            type="submit"
                            className="my-3 w-100"
                            color="primary"
                          >
                            {loading && (
                              <span
                                className="indicator-progress"
                                style={{ display: "block" }}
                              >
                                Please Wait..
                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                              </span>
                            )}
                            {!loading && (
                              <span className="indicator-label">Import</span>
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Container>
            {loader}
          </>
        </form>
      )}
    </Formik>
  );
};

export default ImportVideoGame;


